import { apiClient, Auth, Pagination } from '@/shared/api'

import {
  TContractActionType,
  MasterContractStatus,
  THostMasterContract,
  SortOption,
} from '../model/schema'

export type HostMasterContractsSearchParams = {
  contractMasterStatus?: MasterContractStatus
  fromStartDate?: string
  toStartDate?: string
  fromEndDate?: string
  toEndDate?: string
  roomNameOrAddress?: string
  hostContractActionType?: TContractActionType
  sortBy?: SortOption
  page: number
  size: number
}

export const getHostMasterContracts = async (
  params: HostMasterContractsSearchParams,
) => {
  const { data } = await apiClient.get<Pagination<THostMasterContract>>({
    endpoint: `/v2/host/contracts/masters`,
    queryParams: params,
    auth: Auth.REQUIRED,
  })

  return data
}
